import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=bb18ed20&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb18ed20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb18ed20')) {
      api.createRecord('bb18ed20', component.options)
    } else {
      api.reload('bb18ed20', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=bb18ed20&scoped=true&", function () {
      api.rerender('bb18ed20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ZBWlCsU4sYtm/JS/comp/Accordion.vue"
export default component.exports